/// <reference path="../../vite-env.d.ts" />
import type { EmployerApi } from './employer-client'
import { EmployerHttpApi } from './employer-http'
import { EmployerMockApi } from './employer-mock'

const baseUrl = import.meta.env?.VITE_API_BASE_URL as string | undefined

export const employerApi: EmployerApi = baseUrl
  ? new EmployerHttpApi(baseUrl)
  : new EmployerMockApi()

export { EmployerMockApi, EmployerHttpApi }
export type { EmployerApi, EmployerShiftFilters } from './employer-client'
